import type { ReactNode } from "react";

import styles from "./EmptyState.module.css";

export interface EmptyStateProps {
  title: string;
  action?: ReactNode;
}

/** Float with ripples, one sentence and at most one action. */
export function EmptyState({ title, action }: EmptyStateProps) {
  return (
    <div className={styles.empty}>
      <svg width="96" height="72" viewBox="0 0 96 72" aria-hidden="true" focusable="false">
        <line x1="48" y1="8" x2="48" y2="18" stroke="var(--ink)" strokeWidth="2" strokeLinecap="round" />
        <circle cx="48" cy="34" r="14" fill="var(--surface)" stroke="var(--ink)" strokeWidth="2" />
        <path d="M34 34a14 14 0 0 1 28 0Z" fill="var(--brand)" />
        <path
          d="M14 58c10-5 22-7 34-7s24 2 34 7"
          fill="none"
          stroke="var(--line6)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M26 66c7-3 14-4 22-4s15 1 22 4"
          fill="none"
          stroke="var(--line5)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <p className={styles.title}>{title}</p>
      {action}
    </div>
  );
}
